module.exports = __webpack_public_path__ + "img/bathroom-interior-1457847.4e9e2053.jpg";